'use client';

import type { UpdatingDataCriteria, UpdatingDataValue } from '~/components/Profile/model';
import type { CriteriaType } from '~/model/CriteriaType';
import { VpIcon } from '@vtmn-play/react/headless';
import { VtmnTextInput } from '@vtmn/react';
import { useLocale, useTranslations } from 'next-intl';
import { retrieveTranslatedLabel } from '~/components/Interaction/Form/utils';
import { AcceptLanguage } from '~/const/locale';

export const CriteriaInteger = ({
  criteria,
  userValue,
  updatingUserValue,
  handleChange,
  sportId,
  required,
  helperText,
  noLabel = false,
}: {
  criteria: CriteriaType;
  userValue: number;
  updatingUserValue: UpdatingDataValue;
  handleChange: (obj: UpdatingDataCriteria) => void;
  sportId?: number;
  required?: boolean;
  helperText?: string;
  noLabel?: boolean;
}) => {
  const locale = useLocale();
  const t = useTranslations('PROFILE');

  const type = criteria.type;
  const criteriaUri = criteria['@id'];
  const hasBeenCleared = updatingUserValue === null;
  const value = updatingUserValue?.value_int
    ? updatingUserValue.value_int
    : userValue || '';
  const inputValue = hasBeenCleared ? '' : value;

  const handleChangeValue = (e) => {
    return handleChange({
      value:
        e !== null && e?.target?.value !== ''
          ? { value_int: Number.parseInt(e?.target.value, 10) }
          : null,
      criteriaUri,
      type,
      ignore: !userValue && !e && e !== null,
    });
  };
  const isOnError = required && !inputValue;
  const errorText = isOnError ? helperText : '';

  return (
    <div className="profile__field" data-testid="criteria-integer">
      <div className="vtmn-text-input_container" data-testid="integer">
        <VtmnTextInput
          labelText={
            noLabel
              ? null
              : retrieveTranslatedLabel(
                  criteria,
                  AcceptLanguage[locale],
                )
          }
          id={`criteria-${sportId || ''}${criteria.id}`}
          identifier={`criteria-${sportId || ''}${criteria.id}`}
          type="number"
          value={inputValue}
          required
          onChange={handleChangeValue}
          error={isOnError}
          helperText={errorText}
        />
        {inputValue && (
          <button
            type="button"
            data-testid="clear"
            className="profile__delete-button"
            title={t('GLOBAL.DELETE')}
            onClick={() => handleChangeValue(null)}
          >
            <VpIcon name="close" />
          </button>
        )}
      </div>
    </div>
  );
};
